import Store from '~/store/undux';
import Stick from '~/components/stick/stick';
import { cleanYouTubeBody, getDate } from '~/utils/utils';
import { useState, useEffect } from 'react';
import Share from '~/components/share/share';
import YouTubePlayer from '../videoPlayers/youTubePlayer';
import YouTubeCarouselRecommendations from '~/components/carouselRecommendations/youtubeCarouselRecommendations';
import GetGraphQLClient from "~/utils/GetGraphQLClient";
import GET_YOUTUBE_OVERRIDE from '~/graphql/GET_YOUTUBE_OVERRIDE.graphql';

/**
 * YouTube video block: player and optional recommendations carousel.
 * @param {object} props.data - Page/video data.
 * @param {object} [props.recommendations] - Playlists (first tray used for carousel).
 */
const YouTubeVideoBlock = (props) => {
  const { currentVideo, recommendations } = props;

  const [bodyOverrideMap, setBodyOverrideMap] = useState({});
  const description = currentVideo?.body ?? currentVideo?.description ?? '';

  useEffect(() => {
    async function fetchData() {
      // We check if the ID is already in the map. This avoids fetching the same item twice during a session
      if (currentVideo?.id && !bodyOverrideMap[currentVideo?.id]) {
        try {
          const client = new GetGraphQLClient(`ytDescOver-${currentVideo?.id}`, 'cors', false, false);
          const override = await client.request(GET_YOUTUBE_OVERRIDE, { youtube_id: currentVideo?.id });
          const overrideDesc = override?.youtubeDescriptionQuery?.description
              ? JSON.parse(override.youtubeDescriptionQuery.description)?.value
              : null;

          if (overrideDesc) {
            setBodyOverrideMap({
              ...bodyOverrideMap,
              [currentVideo?.id]: overrideDesc
            });
          }
        } catch (error) {
          console.error('Error fetching YouTube override:', error);
        }
      }
    }

    fetchData();
  }, [currentVideo]);

  return (
    <div className='content'>
      <div className='content__header-video'>
        <div className='content__header-video-wrap'>
          <Stick>
            <YouTubePlayer currentVideo={currentVideo} />
          </Stick>
        </div>
      </div>
      {recommendations?.length > 1 && (
        <YouTubeCarouselRecommendations playlist={recommendations} />
      )}
      <div className='constrain'>
        <div className='content__body'>
          <div className='content__share desktop-only'>
            <Share title={ currentVideo.title } />
          </div>
          {/* Title */}
          <h1 className='content__title-sm'>
            { currentVideo.title }
          </h1>
          {/* Kicker */}
          { currentVideo.field_kicker &&
            <div className='content__flag'>
              { currentVideo.field_kicker }
            </div>
          }
          {/* Date */}
          { currentVideo.field_display_date &&
            <div className='content__byline'>
              <div className='content__byline-date'>
                { getDate(currentVideo.field_display_date) }
              </div>
            </div>
          }
          {/* Body */}
          { (currentVideo.body || bodyOverrideMap[currentVideo?.id]) &&
            <div className='content__body-main content__body-main--larger'>
              <div className='ctd-body content__youtube-desc'>
                <p>
                  <span dangerouslySetInnerHTML={{__html: bodyOverrideMap[currentVideo?.id] ?? cleanYouTubeBody(bodyOverrideMap[currentVideo?.id] ?? cleanYouTubeBody(description), currentVideo?.id)}}/>
                </p>
              </div>
            </div>
          }
          <div className='content__spacer'></div>
          <div data-ad-ref='leader-plus-flex-top' className='bidbarrel-ad'></div>
          <div data-ad-ref='mobile-plus-flex-top' className='bidbarrel-ad'></div>
        </div>
      </div>
    </div>
  );
};


export default Store.withStore(YouTubeVideoBlock);
